import type { LanguageCode } from "config/languages";

const generateFlagKey = (language: LanguageCode): string => {
  switch (language) {
    case "en":
      return "EnUs";
    case "pt-pt":
      return "Pt";
    default:
      return language.replace(/^[a-z]|-[a-z]/g, (match) => match.toUpperCase()).replace("-", "");
  }
};

export default generateFlagKey;
